<template>
  <v-list-group
    :prepend-icon="icon"
  >
    <template v-slot:activator>
      <v-list-item-title>{{title}}</v-list-item-title>
    </template>
    <v-list-item
      :key="item.text"
      v-for="item in items">
        <MenuItem :item="item" />
    </v-list-item>
  </v-list-group>
</template>

<script>
import MenuItem from './MenuItem'
export default {
  props: [
    'icon',
    'title',
    'items'
  ],
  components: {
    MenuItem
  }
}
</script>

<style>

</style>
